module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    staticClass: "main-container",
    attrs: {
      "title": "Library",
      "container": true
    }
  }, [_c('div', {
    staticClass: "container profile"
  }, [_c('div', {
    staticClass: "section profile-heading"
  }, [_c('div', {
    staticClass: "columns"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.library) ? _c('div', {
    staticClass: "column name"
  }, [_c('p', [(!_vm.editing && _vm.library.title) ? _c('span', {
    staticClass: "title is-bold"
  }, [_vm._v(_vm._s(_vm.library.title))]) : _vm._e(), _vm._v(" "), (_vm.editing && _vm.library.title) ? _c('input', {
    ref: "title",
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.library.title
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing && _vm.library.description) ? _c('textarea', {
    ref: "description",
    staticClass: "textarea",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.library.description
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('input', {
    staticClass: "button is-primary is-outlined follow",
    attrs: {
      "type": "button",
      "name": "Edit",
      "value": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('input', {
    staticClass: "button is-primary is-outlined follow",
    attrs: {
      "type": "button",
      "name": "Cancel",
      "value": "Cancel"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('input', {
    staticClass: "button is-info follow",
    attrs: {
      "type": "button",
      "name": "Save",
      "value": "Save"
    },
    on: {
      "click": _vm.updateLibrary
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.editing && _vm.library.description) ? _c('p', {
    staticClass: "tagline"
  }, [_vm._v(" " + _vm._s(_vm.library.description))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.library) ? _c('div', {
    staticClass: "column is-3 following has-text-centered"
  }, [_c('p', {
    staticClass: "stat-val"
  }, [_vm._v(_vm._s(_vm.videos.length))]), _vm._v(" "), _c('p', {
    staticClass: "stat-key"
  }, [_vm._v("videos")])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticClass: "search-box-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input search-box",
    attrs: {
      "type": "text",
      "placeholder": "Search for a video"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-warning",
    attrs: {
      "type": "button",
      "value": "+ Add Video",
      "name": "add video"
    },
    on: {
      "click": function($event) {
        _vm.showAddVideoModal = true
      }
    }
  })])]), _vm._v(" "), (!_vm.loading && _vm.library) ? _c('div', {
    staticClass: "card-container"
  }, [_vm._l((_vm.searchResults), function(video) {
    return (_vm.searchResults.length > 0) ? _c('LibraryVideo', {
      key: video.id,
      attrs: {
        "video": video,
        "libraryID": _vm.libraryID
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.searchResults.length === 0) ? _c('div', [_c('h1', [_vm._v("No videos match "), _c('strong', [_vm._v("\"" + _vm._s(_vm.query) + "\"")])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.showAddVideoModal) ? _c('AddVideoModal', {
    attrs: {
      "cycleID": -99,
      "videoID": -99,
      "hideCycles": true
    },
    on: {
      "close": function($event) {
        _vm.showAddVideoModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-eeacba2e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Library.vue
// module id = 1096
// module chunks = 0